import {callServer} from '../utils/request-util.js';
import environment from 'environment';

export function fetchReconciliationsConfigurations() {
  // const entityId = 'ontime.global.il';
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/list`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function exportReconciliationsConfigurations() {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/export`,
      method: 'GET',
      responseType: "blob",
    }).then(
        response => resolve(response),
        error => reject(error.response)
    );
  });
}

export function importReconciliationsConfigurations(file) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/import`,
      method: 'POST',
      data: file,
    }).then(
        response => resolve(response),
        error => reject(error.response)
    );
  });
}

export function postReconciliationsConfiguration(data) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reconciliation/configurations/create",
      method: "POST",
      data
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function updateReconciliationsConfiguration({ data, configurationId }) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/${configurationId}`,
      method: "PUT",
      data
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function getMergedConfiguration(configId, parentId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/${configId}/merged/${parentId}`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function fetchReconciliationsConfigurationDepots(territoryId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/${territoryId}/depots`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function fetchReconciliationsConfigurationDepotsWithoutTerritory() {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/depots`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function updateReconciliationsPeriod({ data, id }) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${id}/offset`,
      method: "POST",
      data
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function deleteReconciliationsConfiguration(configurationId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/configurations/${configurationId}`,
      method: "DELETE",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function fetchReconciliationsPeriods() {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reconciliation/summary",
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function fetchReconciliationsPeriodById(id) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reconciliation/" + id,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function postReconciliationsPeriods(data) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reconciliation",
      method: "POST",
      data
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function deleteReconciliationsPeriods(configurationId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${configurationId}`,
      method: "DELETE",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function xlsReconciliationsPeriod(periodId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/table`,
      method: "GET",
      responseType: "blob",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function invoiceReconciliationsPeriod(periodId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/pdf`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function recalculateReconciliationsPeriod({periodRewriteSourceDataModel, periodId}) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/recalculate`,
      method: "POST",
      data: {
        RewriteSourceData: periodRewriteSourceDataModel
      },
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function approveReconciliationsPeriod(periodId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/approve`,
      method: "PUT",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function exportReconciliationsPeriod(periodId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/table`,
      method: "GET",
      responseType: "blob",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function exportReconciliationsPeriodTableXls(periodId, type, depotId) {
  return new Promise((resolve, reject) => {
    const encoded = encodeURIComponent(depotId).replace(/\./g, '%2E');
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/table/${type}/${encoded}`,
      method: "GET",
      responseType: "blob",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function exportReconciliationsPeriodTableInvoice(periodId, type, depotId) {
  if(type === "depot") {
    return new Promise((resolve, reject) => {
      callServer({
        url: environment.backendAPI + `reconciliation/${periodId}/pdf/depot/${depotId}`,
        method: "GET",
        responseType: "blob",
      }).then(response => resolve(response), error => reject(error.response));
    });
  }
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reconciliation/${periodId}/pdf/territory`,
      method: "POST",
      data: {
        TerritoryId: depotId,
      },
      responseType: "blob",
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export function depotReconciliationsSettingsGet(depotId) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `restaurant/depot/depotReconciliationSettings/${depotId}`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function depotReconciliationsSettingsEdit(depotId, data) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `restaurant/depot/depotReconciliationSettings/${depotId}`,
      method: "POST",
      data
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function reconciliationsSettingsGet() {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `restaurant/reconciliationSettings`,
      method: "GET",
    }).then(response => resolve(response), error => reject(error.response));
  });
}
export function reconciliationsSettingsEdit(data) {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `restaurant/reconciliationSettings`,
      method: "POST",
      data,
    }).then(response => resolve(response), error => reject(error.response));
  });
}